module.exports = __webpack_public_path__ + "img/icon-sus.e917ed5c.svg";